import { useSuspenseQuery } from '@tanstack/react-query';

import { getAccountOptions } from '@lib/api/options/auth';

export const useAccount = () => {
  const { data: account } = useSuspenseQuery(getAccountOptions());

  return account;
};
